export default __webpack_public_path__ + "static/media/focus2.007c3cd9.png";